import Button from './Button'

export { default as BaseButton } from './Button'
export type { ButtonProps } from './Button'

export default Button
